import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ApiService from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';

const BrandMaster = ({ Currency }) => {
  const location = useLocation();
  const token = localStorage.getItem('Token');
  const navigate = useNavigate();
  const [editCurrency, setEditCurrency] = useState(location.state || null);
  const [currencies, setCurrencies] = useState([]);
  const [canAdd, setCanAdd] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    code: '',
    default: false,
  });

  useEffect(() => {
    getCurrency();
    if (editCurrency) {
      setFormData(editCurrency);
    }
  }, [editCurrency]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    if (editCurrency && !canEdit) {
      toast.error('You do not have permission to edit Brand.');
      return;
    }

    if (!editCurrency && !canAdd) {
      toast.error('You do not have permission to add Brand.');
      return;
    }

    try {
      const apiService = new ApiService();
      const endpoint = editCurrency ? 'UPDATE_CURRENCY' : 'CREATE_CURRENCY';
      const response = editCurrency ? await apiService.put(endpoint, formData) : await apiService.post(endpoint, formData);

      if (response?.status === 200 || response?.status === 201) {
        toast.success(response.data.message);
        getCurrency();
        resetFormData();
      }
    } catch (error) {
      console.error('Error saving Brans:', error);
      toast.error('Error saving Brand');
    }
  };

  const resetFormData = () => {
    setFormData({
      name: '',
      code: '',
      default: false,
    });
    setEditCurrency(null);
  };

  const getCurrency = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_CURRENCY');
      setCurrencies(res?.data?.result);
    } catch (error) {
      console.error('Error fetching currency data:', error);
      toast.error('Error fetching currency data');
    }
  };

  const handleEditCurrency = (currency) => {
    setFormData(currency);
    setEditCurrency(currency);
  };

  return (
    <div className="p-5 m-0">
      <button className="btn addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div className="catlist">
        <div className="row">
          <div className="col-lg-5">
            <label>Brand Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData?.name}
              onChange={handleInputChange}
              placeholder="Currency Name"
              required
              disabled={!canAdd && !editCurrency}
            />
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-5">
            <label>Brand Code</label>
            <input
              type="text"
              className="form-control"
              name="code"
              value={formData?.code}
              onChange={handleInputChange}
              placeholder="Currency Code"
              required
              disabled={!canAdd && !editCurrency}
            />
          </div>
        </div>

        <div className="row mt-5 mb-5 d-flex justify-content-center">
          <div className="col-lg-2">
            <button className="addItem-btn" onClick={handleSave} disabled={!canAdd && !editCurrency}>
              Save
            </button>
          </div>
        </div>
      </div>

      <div className="mt-5">{/* <CurrencyGrid data={currencies} onEditCurrency={handleEditCurrency} GetModifier={getCurrency} /> */}</div>
    </div>
  );
};

const mapStateToProps = (state) => state;
export default connect(mapStateToProps)(BrandMaster);
